var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favor",on:{"click":function($event){$event.stopPropagation();return _vm.toggleLike()}}},[_c('v-icon',{attrs:{"color":_vm.favColor,"small":""}},[_vm._v("mdi-heart")]),_c('span',{staticClass:"favor-count"},[_vm._v(_vm._s(_vm.biz.stats?.fav))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }